function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSmLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 68,
    height: 40,
    preserveAspectRatio: "xMidYMid",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    style: {
      marginRight: "-2px",
      display: "block",
      animationPlayState: "paused"
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("style", {
    type: "text/css",
    style: {
      animationPlayState: "paused"
    }
  }, "text {\n    text-anchor: middle; font-size: 29px; opacity: 0;\n  }"), /*#__PURE__*/React.createElement("g", {
    style: {
      transformOrigin: "34px 20px",
      transform: "matrix(1, 0, 0, 1, 0, 0)",
      animationPlayState: "paused"
    }
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(34,20)",
    style: {
      transform: "matrix(1, 0, 0, 1, 34, 20)",
      animationPlayState: "paused"
    }
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0,0)",
    style: {
      transform: "matrix(1, 0, 0, 1, 0, 0)",
      animationPlayState: "paused"
    }
  }, /*#__PURE__*/React.createElement("g", {
    className: "path",
    style: {
      transformOrigin: "-14.165px -2.19494px",
      animationTimingFunction: "linear",
      animationPlayState: "paused",
      animationName: "static-a01095a2-da67-4fa9-abac-0933b04f2fc5",
      animationIterationCount: "infinite",
      animationFillMode: "forwards",
      animationDuration: "100s",
      animationDelay: "-44s"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.38-2.64L2.64-5.77L2.64-5.77Q5.10-3.31 7.57-3.31L7.57-3.31L7.57-3.31Q8.85-3.31 9.61-3.90L9.61-3.90L9.61-3.90Q10.38-4.50 10.38-5.44L10.38-5.44L10.38-5.44Q10.38-6.38 9.45-7.03L9.45-7.03L9.45-7.03Q8.53-7.69 7.21-8.18L7.21-8.18L7.21-8.18Q5.89-8.67 4.58-9.29L4.58-9.29L4.58-9.29Q3.28-9.92 2.35-11.08L2.35-11.08L2.35-11.08Q1.42-12.24 1.42-13.89L1.42-13.89L1.42-13.89Q1.42-16.50 3.60-18.40L3.60-18.40L3.60-18.40Q5.77-20.30 8.76-20.30L8.76-20.30L8.76-20.30Q10.12-20.30 11.40-20.01L11.40-20.01L11.40-20.01Q12.67-19.72 13.86-19.17L13.86-19.17L11.89-14.94L11.89-14.94Q11.08-15.57 9.67-16.11L9.67-16.11L9.67-16.11Q8.27-16.65 7.21-16.65L7.21-16.65L7.21-16.65Q6.15-16.65 5.50-16.14L5.50-16.14L5.50-16.14Q4.84-15.63 4.84-14.79L4.84-14.79L4.84-14.79Q4.84-13.95 5.77-13.30L5.77-13.30L5.77-13.30Q6.70-12.64 8.02-12.15L8.02-12.15L8.02-12.15Q9.34-11.66 10.66-11.06L10.66-11.06L10.66-11.06Q11.98-10.47 12.91-9.31L12.91-9.31L12.91-9.31Q13.83-8.15 13.83-6.50L13.83-6.50L13.83-6.50Q13.83-3.77 11.66-1.73L11.66-1.73L11.66-1.73Q9.48 0.32 6.58 0.32L6.58 0.32L6.58 0.32Q4.41 0.32 2.73-0.73L2.73-0.73L2.73-0.73Q1.25-1.62 0.64-2.32L0.64-2.32L0.38-2.64",
    fill: "#243123",
    stroke: "none",
    strokeWidth: "none",
    transform: "translate(-21.285003662109375,7.795060017903653)",
    style: {
      transform: "matrix(1, 0, 0, 1, -21.285, 7.79506)",
      fill: "rgb(36, 49, 35)",
      animationPlayState: "paused"
    }
  })), /*#__PURE__*/React.createElement("g", {
    className: "path",
    style: {
      transformOrigin: "4.875px 0.49006px",
      animationTimingFunction: "linear",
      animationPlayState: "paused",
      animationName: "static-a01095a2-da67-4fa9-abac-0933b04f2fc5",
      animationIterationCount: "infinite",
      animationFillMode: "forwards",
      animationDuration: "100s",
      animationDelay: "-22s"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24.68-7.34L24.68-7.34Q24.68-9.34 24.33-10.01L24.33-10.01L24.33-10.01Q23.98-10.67 22.71-10.67L22.71-10.67L22.71-10.67Q21.43-10.67 19.81-9.66L19.81-9.66L19.81-7.54L20.13-0.73L16.24 0L16.59-7.05L16.59-7.05Q16.47-10.93 15.95-14.01L15.95-14.01L19.46-14.76L19.46-14.76Q19.66-13.08 19.75-11.48L19.75-11.48L19.75-11.48Q20.18-12.06 20.74-12.63L20.74-12.63L20.74-12.63Q21.29-13.20 22.48-13.91L22.48-13.91L22.48-13.91Q23.66-14.62 24.88-14.62L24.88-14.62L24.88-14.62Q26.10-14.62 26.94-13.83L26.94-13.83L26.94-13.83Q27.78-13.05 28.01-11.69L28.01-11.69L28.01-11.69Q30.42-14.62 32.89-14.62L32.89-14.62L32.89-14.62Q34.42-14.62 35.32-13.59L35.32-13.59L35.32-13.59Q36.22-12.56 36.22-10.79L36.22-10.79L36.05-7.54L36.37-0.58L32.45 0.15L32.80-7.34L32.80-7.34Q32.80-9.34 32.45-10.01L32.45-10.01L32.45-10.01Q32.10-10.67 30.86-10.67L30.86-10.67L30.86-10.67Q29.61-10.67 28.04-9.71L28.04-9.71L27.93-7.54L28.25-0.58L24.33 0.15L24.68-7.34",
    fill: "#243123",
    stroke: "none",
    strokeWidth: "none",
    transform: "translate(-21.285003662109375,7.795060017903653)",
    style: {
      transform: "matrix(1, 0, 0, 1, -21.285, 7.79506)",
      fill: "rgb(36, 49, 35)",
      animationPlayState: "paused"
    }
  })), /*#__PURE__*/React.createElement("g", {
    className: "path",
    style: {
      transformOrigin: "19.56px 5.73506px",
      animationTimingFunction: "linear",
      animationPlayState: "paused",
      animationName: "static-a01095a2-da67-4fa9-abac-0933b04f2fc5",
      animationIterationCount: "infinite",
      animationFillMode: "forwards",
      animationDuration: "100s"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M38.74-1.94L38.74-1.94L38.74-1.94Q38.74-2.87 39.43-3.58L39.43-3.58L39.43-3.58Q40.11-4.29 41.06-4.29L41.06-4.29L41.06-4.29Q42.95-4.29 42.95-2.38L42.95-2.38L42.95-2.38Q42.95-1.28 42.27-0.55L42.27-0.55L42.27-0.55Q41.59 0.17 40.67 0.17L40.67 0.17L40.67 0.17Q39.76 0.17 39.25-0.42L39.25-0.42L39.25-0.42Q38.74-1.02 38.74-1.94",
    fill: "#243123",
    stroke: "none",
    strokeWidth: "none",
    transform: "translate(-21.285003662109375,7.795060017903653)",
    style: {
      transform: "matrix(1, 0, 0, 1, -21.285, 7.79506)",
      fill: "rgb(36, 49, 35)",
      animationPlayState: "paused"
    }
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSmLogo);
export default __webpack_public_path__ + "static/media/Sm_logo.60a150811d3e99337a8dd94616aa95e3.svg";
export { ForwardRef as ReactComponent };